import { IPhoneCallApi } from '../interfaces/api/phone-call.interface';
import { COMMON } from '../../../configs/main.config';
import { IPhoneCall } from '../../../shared/interfaces/phone-call.interface';
import { Direction } from '../../../shared/types/call-history';

const getPhoneNumber = (phoneCallApi: IPhoneCallApi): string => {
  if (!phoneCallApi.phonenumber) {
    const phone = phoneCallApi?.subject?.match(/\(.+\)/)?.[0] ?? '';
    return phone.replace(/\(|\)/g, '');
  }

  return phoneCallApi.phonenumber;
};

const mapDirection = (direction: boolean): Direction => {
  return direction ? 'outbound' : 'inbound';
};

export const phoneCallApiMapper = (phoneCallApi: IPhoneCallApi): IPhoneCall => {
  const fullName = phoneCallApi._regardingobjectid_value
    ? phoneCallApi[
        '_regardingobjectid_value@OData.Community.Display.V1.FormattedValue'
      ]
    : COMMON.UNKNOWN;

  const direction = mapDirection(phoneCallApi.directioncode);
  const phoneNumber = getPhoneNumber(phoneCallApi);

  return {
    id: phoneCallApi.activityid,
    durationFormatted: phoneCallApi.solgari_durationformatted,
    date: new Date(phoneCallApi.createdon),
    fullName,
    direction,
    subject: phoneCallApi.subject,
    phoneNumber,
  };
};
